import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Form } from 'react-form';
import {
    Input,
} from '../../components/Form';
import { impersonateMember } from '../../actions';
import { createReactFormValidator, requiredEmail } from '../../utils/validation';

import styles from './forgotPassword.scss';

class ImpersonateMemberPage extends Component {
    constructor(props) {
        super(props);
        if (props.auth && props.auth.user && !props.auth.user.isAdmin) {
            props.history.replace('/home'); // o to dashboard if not admin
        }

        this.state = {
            submitting: false,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    async handleSubmit(values) {
        this.setState({
            submitting: true,
        });
        if (values.memberEmail) {
            await this.props.impersonateMember(values.memberEmail);
            this.props.history.replace('/home');
        }
        this.setState({
            submitting: false,
        });
    }

    render() {
        const defaultValues = {
            memberEmail: null,
        };

        return (
            <div className={`${styles.section}`}>
                <div className={`container`}>
                    <div className="row">
                        <div className={`col-md-6 offset-md-3`}>
                            <React.Fragment>
                                <h3 className="mb24" data-testid="impersonate-member.page.title">
                                    Impersonate User
                                </h3>
                                <Form onSubmit={values => this.handleSubmit(values)} defaultValues={defaultValues}>
                                    {({ submitForm }) => {
                                        return (
                                            <form onSubmit={submitForm} id="forgotPasswordForm" data-testid="impersonate-member.page.form">
                                                <Input
                                                    id="memberEmail"
                                                    field="memberEmail"
                                                    type="text"
                                                    description="Member Email To Switch To"
                                                    placeholder="Member Email"
                                                    validate={createReactFormValidator(requiredEmail)}
                                                    data-testid="impersonate-member.page.email-input"
                                                />
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary btn-xl text-uppercase btn-block"
                                                    disabled={this.state.submitting}
                                                    data-testid="impersonate-member.page.submit-btn"
                                                >
                                                    Impersonate User
                                                </button>
                                            </form>
                                        );
                                    }}
                                </Form>
                            </React.Fragment>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        impersonateMember: (memberEmail) => dispatch(impersonateMember(memberEmail)),
    };
}

function mapStateToProps({ auth }) {
    return { auth };
}

export default connect(mapStateToProps, mapDispatchToProps)(ImpersonateMemberPage);
